import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiGet } from "../helpers/request.helpers";
import { fetchLang } from "../helpers/language.helpers";
import { School } from "../types/school.types";

export const allSchoolsQueryOptions = queryOptions({
  queryKey: ["all-schools", "admin"],
  queryFn: async () => {
    const data = await apiGet("/admin/list-schools", {
      language: fetchLang(),
    });
    const list: School[] = data.Schools ?? [];
    const map: Map<number, School> = new Map();
    list.forEach((s) => {
      map.set(s.ID, s);
    });
    return { list, map };
  },
  staleTime: 1000 * 60 * 4,
});

export function useAllSchools() {
  return useQuery(allSchoolsQueryOptions);
}
